/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Locations/view.blocks to change it.
import * as fromData from 'Simple/Data'
import LocationChoice from 'DesignSystem/LocationChoice/index'
import Map from 'DesignSystem/Map/react'
import MaskedInput from 'DesignSystem/MaskedInput/index'
import React from 'react'
import ViewsStream from 'Simple/Stream/react-dom'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Locations({
  children,
  viewPath = "/App/Form/Data/ProvideData/Location/Content/Locations",
  focusArea,
  onChange,
  inputKey,
  zipInput,
  choices,
  onMouseEnter,
  onMouseLeave,
  setHighlightedLocation,
  onSelect,
  selected,
  dentalPlan,
  selectedLocationVisitType,
  highlightedLocation,
  listElementRef,
  center,
  hoveredMarker,
  markers,
  userLocation
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
  return (<React.Fragment
>
<div
  data-testid="Locations.Vertical"
  data-view-path={viewPath}
 ref={focusArea}
 style={{'--o-1-WgnH6': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<MaskedInput
  viewPath={`${viewPath}/MaskedInput`}
 borderBottomLeftRadius={4}
 borderBottomRightRadius={4}
 borderTopLeftRadius={4}
 borderTopRightRadius={4}
 borderColor="#606060"
 borderStyle="solid"
 borderWidth={1}
 paddingBottom={8}
 paddingRight={8}
 paddingLeft={8}
 paddingTop={8}
 mask="fiveDigits"
 onChange={onChange}
 placeholder="Use your zipcode to order by distance"
 type="text"
 marginBottom={10}
 key={inputKey}
 initialValue={zipInput}
/>
<div
  data-testid="Locations.Horizontal"
  data-view-path={viewPath}
 style={{'--fd-2-WgnH6': isMedia.mobile ? "column" : "row"}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Locations.ChoiceList"
  data-view-path={viewPath}
 className={`views-block ${styles.ChoiceList}`}
>
<div
  data-testid="Locations.List"
  data-view-path={viewPath}
 key="item.id"
 style={{'--h-3-WgnH6': isMedia.mobile ? "140px" : "500px",'--fd-2-WgnH6': isMedia.mobile ? "row" : "column",'--ox-4-WgnH6': isMedia.mobile ? "auto" : "hidden",'--oy-5-WgnH6': isMedia.mobile ? "hidden" : "auto",'--mt-6-WgnH6': isMedia.mobile ? "5px" : "0px",'--mr-7-WgnH6': isMedia.mobile ? "0px" : "5px"}}
 className={`views-block ${styles.List}`}
>
<ViewsStream
>
{Array.isArray(choices) && choices.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="choice"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/LocationChoice(${item?.id ?? item?._id ?? index})`}
      >
<LocationChoice
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/LocationChoice(${item?.id ?? item?._id ?? index})`}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 onClick={setHighlightedLocation}
 onSelect={onSelect}
 selected={selected}
 dentalPlan={dentalPlan}
 selectedLocationVisitType={selectedLocationVisitType}
 highlightedLocation={highlightedLocation}
 innerRef={listElementRef}
/>
</ListItem>
)}
</ViewsStream>
</div>
</div>
<Map
  viewPath={`${viewPath}/Map`}
 center={center}
 height={isMedia.mobile ? "300px" : "500px"}
 highlightedLocation={highlightedLocation}
 hoveredMarker={hoveredMarker}
 markers={markers}
 setHighlightedLocation={setHighlightedLocation}
 userLocation={userLocation}
 width="100%"
/>
</div>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }